import React from 'react'
import PropTypes from 'prop-types'
import BaseIcon from '../../BaseIcon/BaseIcon'
import { ReactComponent as Component } from './SquareLinkedIn.svg'

const SquareLinkedIn = ({ className }) => {
	return <BaseIcon component={Component} className={className} viewBox="0 0 448 512" />
}

SquareLinkedIn.propTypes = {
	className: PropTypes.string,
}

export default SquareLinkedIn
